import useClientState from '@/state/useClientState';

// Stamgegevens zoals dienstregelpunten en mattypes:
const useDienstregelpunten = () => useClientState((state) => state.dienstregelpunten);
export default useDienstregelpunten;
